<template>
  <div>
    <Nuxt />
  </div>
</template>

<script>
// import Loading from '_c/loading'
export default {
  components: {
    // Loading
  }
}
</script>

<style lang='scss' scoped>
.container {
    width:100% !important;
    .nav-left {
        width: 15%;
        min-width: 180px;
        height: calc(100vh);
        background-color: #fff;
        border-right:1px solid #e0e0e0
    }

    .main {
        height: calc(100vh);
        background-color: #f1f3f5;
    }

    .content {
        position: relative;
        padding: 10px;
    }
}
.logo {
  text-align: center;
  height: 130px;
  padding: 55px 0;
  .logo-img {
    height: 40px;
  }

  .logo-title {
    color: #2D8CF0;
    font-size: 21px;
    margin: auto 0;
  }
}

.header {
  background-color: #ffffff;

  .header-top {
    height: 60px;
    padding:15px 15px 0 15px;
    font-size: 14px;
    .span-top {
      display: inline-block;
      height: 100%;
      margin-right: 55px;
    }
    .icon-top {
      margin-left: 20px;
    }
  }
}
.footer {
    text-align: center;
    color: #999;
}
</style>
